module.exports = __webpack_public_path__ + "static/media/HOMEPAGE_ICONS_SHARE.29a32929.svg";